/**
 * DAOmotion platform detection
 * Apple HIG  → iPhone / iPad / iPod / Mac
 * Material 3 → Android / Windows / Linux / other
 */
(function () {
  var ua = navigator.userAgent || "";
  var platform = navigator.platform || "";
  var root = document.documentElement;

  root.classList.remove("platform-apple", "platform-material");

  var isAppleMobile = /iPhone|iPad|iPod/.test(ua);
  var isMac =
    /Macintosh|Mac OS X/.test(ua) ||
    platform === "MacIntel" ||
    platform === "MacARM";
  /* iPadOS 13+ desktop mode reports as Macintosh with touch */
  var isIpadDesktop = isMac && navigator.maxTouchPoints > 1;

  if (isAppleMobile || isMac || isIpadDesktop) {
    root.classList.add("platform-apple");
  } else {
    root.classList.add("platform-material");
  }
})();
